import { ProductAttributeViewModel } from '@/types/api';
interface Props {
  attributes: ProductAttributeViewModel[];
}
const ProductAttributesTable = ({
  attributes
}: Props) => {
  return <div className='lg:px-3' data-sentry-component="ProductAttributesTable" data-sentry-source-file="product-attributes-table.tsx">
            {attributes.map(({
      id,
      nameFa,
      values
    }) => <div data-test='pdp-product-attributes-table' className='grid grid-cols-3 gap-6 lg:grid-cols-4 [&:not(:last-child)>span]:border-b [&:not(:last-child)>span]:border-solid [&:not(:last-child)>span]:border-gray-100' key={id}>
                    <span className='col-span-1 w-full px-1 py-2 text-body-14 font-medium text-text-darkGray lg:px-2 lg:py-3'>
                        {nameFa}
                    </span>
                    <span className='col-span-2 w-full px-1 py-2 text-caption-12 text-text-black lg:col-span-3 lg:py-3 lg:text-body-14'>
                        {values?.map(({
          nameFa: valueNameFa
        }) => valueNameFa).join('، ')}
                    </span>
                </div>)}
        </div>;
};
export default ProductAttributesTable;